import { TableContainer } from "../../styles";
import { CampoAlterado } from "../../types";

interface BlocoPrincipalProps {
    campos: CampoAlterado[];
}

export default function BlocoPrincipal({ campos }: BlocoPrincipalProps) {
    if (!campos || campos.length === 0) {
        return null;
    }

    return (
        <div className="expanded-section">
            <h4 className="section-title">Principal</h4>
            <TableContainer>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th className="field-col">Campo</th>
                            <th className="before-col">Antes</th>
                            <th className="after-col">Depois</th>
                        </tr>
                    </thead>
                    <tbody>
                        {campos.map((campo, index) => (
                            <tr key={index} className={index > 0 ? "border-top" : ""}>
                                <td className="field-cell">{campo.campo}</td>
                                <td className="before-cell">{campo.antes || '—'}</td>
                                <td className="after-cell">
                                    {campo.depois}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </TableContainer>
        </div>
    );
}

